import styled from "styled-components";
import {
	FONT_WT_MEDIUM,
	FONT_WT_LIGHT,
	FONT_WT_REGULAR,
	COLOR_TEXT_PRIMARY_B2C,
	DESKTOP_SM_BP,
	MOBILE_L_BP,
} from "@website-builder/utilities-index";

export const InvestorsWrapper = styled.div`
	padding: 45px 112px 50px 112px;
	.header {
		text-align: center;
		font-size: 28px;
		font-weight: ${FONT_WT_MEDIUM};
		color: ${COLOR_TEXT_PRIMARY_B2C};
		padding-bottom: 10px;
	}
	.text {
		text-align: center;
		font-size: 16px;
		font-weight: ${FONT_WT_LIGHT};
		color: ${COLOR_TEXT_PRIMARY_B2C};
		line-height: 1.69;
		padding-bottom: 35px;
	}
	.investerWrapper {
		display: flex;
		justify-content: center;
		flex-flow: wrap;
		.container {
			width: 227px;
			background: white;
			margin-left: 3px;
			margin-right: 3px;
			margin-bottom: 30px;
			.description {
				height: 110px;
				text-align: center;
				padding-top: 18px;
				padding-left: 26px;
				padding-right: 26px;
				.name {
					font-size: 18px;
					font-weight: ${FONT_WT_REGULAR};
					color: ${COLOR_TEXT_PRIMARY_B2C};
					padding-bottom: 8px;
				}
				.designation {
					font-size: 16px;
					font-weight: ${FONT_WT_LIGHT};
					color: ${COLOR_TEXT_PRIMARY_B2C};
				}
			}
			.image {
				picture {
					img {
						width: 100% !important;
					}
				}
			}
		}
	}

	@media only screen and (max-width: ${DESKTOP_SM_BP}px) {
		.container {
			margin-left: 7px !important;
			margin-right: 7px !important;
		}
	}

	@media only screen and (max-width: ${MOBILE_L_BP}px) {
		padding: 50px 10px 50px 10px;
		.header {
			padding-bottom: 30px;
			font-size: 26px;
		}
		.text {
			padding-left: 20px;
			padding-right: 20px;
		}
		.container {
			width: 158px !important;
			margin-left: 4px !important;
			margin-right: 4px !important;
			.description {
				height: 85px !important;
				padding: 7px 10px 6px 10px !important;
			}
		}
	}
`;
